module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/divider_dotty.9ffa50bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RatingCard/images/divider_dotty.png
// module id = 3457
// module chunks = 11